<template>
  <v-flex
    class="fill-height flex-fill"
  >
    <v-row
      justify="center"
      align="center"
      class="ma-0 fill-height card-map__row"
    >
      <v-progress-circular
        v-if="isLoading"
        color="accent"
        indeterminate
        class="card-map__progress"
      />
      <div
        :id="`card-map-${processing['id_processing']}`"
        class="fill-height card-map"
      >
      </div>
    </v-row>
  </v-flex>
</template>

<script>
  import L from "leaflet"
  import {TILE_URL} from "../../globals"
  import {isEqual} from "lodash/lang"
  import {
    CAMERA_TYPES, DEFAULT_TILE_TYPE,
    PROCESSING_MAX_ZOOM,
    PROCESSING_MIN_ZOOM,
    PROCESSING_STATUS,
  } from "../../helpers/processings/constants"
  import {listHistogramConfigs} from "../../api/api-tile"
  import {head} from "lodash/array"

  export default {
    name: "ProcessingCardMap",
    props: {
      processing: {
        type: Object,
        required: true,
      },
    },
    data: () => ({
      isLoading: true,
      map: null,
      lstAvailableTiles: [],
      setupTimeout: null,
    }),
    methods: {
      loadTiles(url, bounds) {
        L.tileLayer(
          url,
          {
            bounds,
            minZoom: PROCESSING_MIN_ZOOM,
            maxZoom: PROCESSING_MAX_ZOOM,
            tms: true,
            opacity: 5,
          },
        ).addTo(this.map)
      },
      getBounds() {
        const processingBounds = [
          this.processing["json_processing_extents"]["coord_0"]["longitude"],
          this.processing["json_processing_extents"]["coord_0"]["latitude"],
          this.processing["json_processing_extents"]["coord_2"]["longitude"],
          this.processing["json_processing_extents"]["coord_2"]["latitude"],
        ]

        return L.latLngBounds([
          processingBounds.slice(0, 2).reverse(),
          processingBounds.slice(2, 4).reverse(),
        ])
      },
      setupBaseLayer() {
        L.tileLayer("https://{s}.google.com/vt/lyrs=s,h&x={x}&y={y}&z={z}", {
          attribution: "Map data: &copy; Google Maps",
          subdomains: ["mt0", "mt1", "mt2", "mt3"],
          maxZoom: 21,
          minZoom: 0,
          tms: false,
          label: "Google Maps Hybrid",
        }).addTo(this.map)
      },
      setupBounds() {
        if (this.processing["json_processing_extents"]) {
          const bounds = this.getBounds()
          this.map.fitBounds(bounds)
        }
      },
      async onMounted() {
        await new Promise((resolve, reject) => {
          this.setupTimeout = setTimeout(() => {
            if (!isEqual(this.processing["ab_processing_status"], PROCESSING_STATUS.ENDED)) {
              return reject(new Error("Processamento não finalizado"))
            }
            this.map = L.map(`card-map-${this.processing["id_processing"]}`, {
              drawControl: false,
              zoomControl: true,
              scrollWheelZoom: false,
              positionControl: false,
              doubleClickZoom: this.$vuetify.breakpoint.smAndUp,
              dragging: this.$vuetify.breakpoint.smAndUp,
              tap: false
            })
            this.setupBaseLayer()
            if (this.processing["json_processing_extents"]) {
              const headData = head(this.lstAvailableTiles)
              let productType = (headData) ? headData["ab_tile_name"] : DEFAULT_TILE_TYPE
              const tilesUrl = `${TILE_URL}/tiles/get-processing-tile/${this.processing["id_processing"]}/${productType}/{z}/{x}/{y}?access_token=${this.$apiAuth.getAuthToken()}`
              const bounds = this.getBounds()
              this.loadTiles(tilesUrl, bounds)
              this.map.invalidateSize()
              resolve(this.map)
            } else {
              reject(new Error("Falha ao recuperar extents"))
            }
            this.map.removeControl(this.map.attributionControl)
          }, 3 * 1000)
        })
      },
    },
    computed: {
      isMultispectral() {
        return isEqual(this.processing["ab_camera_type"], CAMERA_TYPES.MULTISPECTRAL)
      },
    },
    mounted() {
      listHistogramConfigs(this.$apiAuth.getAuthToken(), this.processing["id_processing"])
        .then(res => {
          if (res) if (res.data) this.lstAvailableTiles = res.data.data
          this.onMounted()
            .then(() => {
              this.setupBounds()
            })
            .finally(() => {
              this.isLoading = false
            })
        })
    },
    beforeDestroy() {
      clearTimeout(this.setupTimeout)
    }
  }
</script>

<style scoped lang="scss">
  @import "~leaflet/dist/leaflet.css";

  .card-map__row {
    position: relative;
  }

  .card-map {
    z-index: 6;
    width: 100% !important;
  }

  .card-map__progress {
    position: absolute;
  }
</style>
